import { Component, OnInit, Input, Output , EventEmitter} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ElencoBlocchiCancellazionePage } from 'src/app/elenco-blocco-cancellazioni/elenco-blocco-cancellazioni.page';
import { ChiaveConfig } from 'src/app/models/configurazioni/ChiaveConfig';
import { Idoneita } from 'src/app/models/idoneita/idoneita';
import { Inoltro } from 'src/app/models/inoltro';
import { ConteggiGeolocalizzazioni } from 'src/app/models/rilevazione-presenze/conteggi-geolocalizzazioni';
import { ConteggiIdoneita } from 'src/app/models/rilevazione-presenze/conteggi-idoneita';
import { ConfigService } from 'src/app/services/config-service/config-service';
import { IdoneitaService } from 'src/app/services/idoneita-service';
import { UtilityService } from 'src/app/services/utility.service';


@Component({
  standalone: false,
  selector: 'app-info-idoneita',
  templateUrl: './info-idoneita.component.html',
  styleUrls: ['./info-idoneita.component.scss'],
})

export class InfoIdoneitaComponent implements OnInit {
  @Input() idoneita: Idoneita;
  @Input() inoltro: Inoltro;
  @Input() cg: ConteggiGeolocalizzazioni;
  @Input() ci: ConteggiIdoneita;
  @Input() autosaveforsynch: boolean;
  @Input() showInfoIdoneita: boolean;

  @Output() idoSelected = new EventEmitter();
  
  // cleaning = false;
  disableCleaningGeoloc = false;

  dtPossibileCancellazione: Date;
  now: Date;
  automaticDel: boolean;
  giorniPermanenzaInfoGeoloc = 0;

  constructor(
    private idoneitaService: IdoneitaService,
    private utilityService: UtilityService,
    private translateService: TranslateService,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    console.log('ngOnInit', this.idoneita);
    this.automaticDel = this.configService.getConfigurazione(ChiaveConfig.DEL_AUTO_INFO_GEOLOC) === 'true';    
    this.giorniPermanenzaInfoGeoloc = this.configService.getConfigurazione(ChiaveConfig.GIORNI_PERMANENZA_INFO_GEOLOC);
    this.setDisableCleaningGeoloc(false);
  }

  setDisableCleaningGeoloc(cleaning: boolean) {
    this.now = (new Date);
    let locDisableCleaning = false;
    if (this.inoltro) {
      const gpig = this.giorniPermanenzaInfoGeoloc;
      this.dtPossibileCancellazione = new Date(this.inoltro.istante_ultimo_inoltro);
      this.dtPossibileCancellazione = new Date( this.dtPossibileCancellazione.getTime() + (gpig * 24 * 60 * 60 * 1000) );
      this.dtPossibileCancellazione.setHours(23);
      this.dtPossibileCancellazione.setMinutes(59);
      this.dtPossibileCancellazione.setSeconds(59);
      
      console.log('this.inoltro.istante_ultimo_inoltro', this.inoltro.istante_ultimo_inoltro);
      console.log('gpig', gpig)
      console.log('this.dtLimiteRichiestablocco', this.dtPossibileCancellazione);
      
      if (this.now < this.dtPossibileCancellazione) {
        locDisableCleaning = true;
      }
      this.disableCleaningGeoloc = cleaning || locDisableCleaning;
    }



  }

  cancellaInfoGeoloc(idIdo: string) {
    let saveConfirmMessage = this.translateService.instant('gestione-invii.message.geoloc.askconfirm', {
      n: this.cg.countGeolocalizzati - this.cg.countGeolocBlocked
    });
    this.utilityService.presentAlertConfirmCancel(
      saveConfirmMessage,
      this.translateService.instant('gestione-invii.message.title'),
      () => this.cancella(idIdo)
    );
  }

  cancella(idIdo: string) {
    this.setDisableCleaningGeoloc(true);
    this.idoneitaService.deleteInfoGeolocalizzazione(idIdo).subscribe(n => {
      console.log('updatedRecords ' + n);
      this.setDisableCleaningGeoloc(false);
      this.idoSelected.emit(n);
    });
  }

  async viewElencoBlocchi() {
    // recuperare gli studenti e aprire una modale per la visualizzazione 
    // per farci cosa poi ??  come si sbloccano queste cancellazioni?
    const modalResp = await this.utilityService.showModal(ElencoBlocchiCancellazionePage, {idoneita: this.idoneita});
    if (modalResp.data) {
      // this.salvaPresenza(modalResp.data.presenza);
    }
  }
}